import { SubtypeDefinition } from "../actionModule"
import { Subtype } from "./subtype"

export const DefaultUnknownSubtypeDefinition: SubtypeDefinition = {
    name: "Unkown Subtype",
    type: Subtype.Unknown,
    icon: <>?</>,
    toolboxPlaceholder: () => <>Unknown subtype</>,
    editorPreview: () => <>Unknown subtype</>,
    editableProperties: []
}